import { createServerOnlyFn } from "@tanstack/react-start";
import { dispatchKitsReminder } from "./reminder-dispatch.server.ts";

const dispatch = createServerOnlyFn(({ request }: { request: Request }) =>
    dispatchKitsReminder(request),
);

export const legacyReminderDispatchRoute = {
    server: { handlers: { POST: dispatch } },
};
